export enum StatusItemType {
  DefaultButton,
  ToggleButton,
}
